import api from '@/apis/di/dbOptionAPI';
import Crud from './crudBase';
import indexedDB from '@/commons/indexedDB';

var crud = new Crud('dbOption', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_dboption',
    field: {
      key: 'option_id',
      code: 'option_code',
      name: 'option_name',
    },
  },
  dbOptions: {},
};
const getters = {
  ...crud.getters,
  dbOptions: () => state.dbOptions,
  heightOption: state => {
    return state.dbOptions?.HeightOption || 2;
  },
  lineHeight: state => {
    switch (state.dbOptions?.HeightOption) {
      case 1:
        return 18;
      default:
        return 19.5;
    }
  },
  inputHeight: state => {
    switch (state.dbOptions?.HeightOption) {
      case 1:
        return 22;
      default:
        return 26;
    }
  }
};
const actions = {
  ...crud.actions,
  loadFullCache: async function ({ dispatch, commit, getters }, payload) {
    if (!payload) {
      payload = {};
    }
    const key = 'cache_dbOption';
    const indexDb = new indexedDB();
    const data = await indexDb.get(key);

    if (data) {
      const { localVersion, localData } = data;

      if (payload.isReload && !payload.remoteVersion) {
        payload.remoteVersion = localVersion;
      }

      if (localVersion < payload.remoteVersion || !localData || payload.isReload) {
        const remoteData = await dispatch(`getFullDbOptions`);
        await indexDb.set(key, {
          localVersion: payload.remoteVersion,
          localData: remoteData
        });
        commit('cacheDbOptions', remoteData);
      } else {
        commit('cacheDbOptions', localData);
        if (payload.remoteVersion == undefined) {
          await indexDb.set(key, {
            localVersion: payload.remoteVersion,
            localData: localData,
          });
        }
      }
    } else {
      const remoteData = await dispatch(`getFullDbOptions`);
      await indexDb.set(key, {
        localVersion: payload.remoteVersion,
        localData: remoteData
      });
      commit('cacheDbOptions', remoteData);
    }
  },
  // service lấy full dbOption
  async getFullDbOptions(context) {
    let res = await api.getDbOptions({});
    return res;
  },
  /**
   * Load option
   */
  async getDbOptions(context, payload) {
    payload = payload || {};
    try {
      context.commit('updateLoading', true);
      if (payload.reload || !state.dbOptions || Object.keys(state.dbOptions).length == 0) {
        await context.dispatch('loadFullCache', { isReload: true });
      }
    } finally {
      context.commit('updateLoading', false);
    }
    return { ...state.dbOptions };
  },
  /**
   * Update dbOption
   */
  async updateDbOptions(context, payload) {
    let res = null;
    try {
      context.commit('updateLoading', true);
      let data = { ...state.dbOptions, ...payload };
      context.commit('cacheDbOptions', { ...state.dbOptions, ...payload });
      res = await api.updateDbOptions(payload || {});
    } finally {
      context.commit('updateLoading', false);
    }

    return res;
  },

  /**
   * Update dbOption
   */
  resetDbOptions(context, payload) {
    context.commit('cacheDbOptions', {});
  },

  /**
   * Cache dbOption
   */
  updateCacheDbOptions(context, payload) {
    context.commit('cacheDbOptions', { ...state.dbOptions, ...payload });
  },
};
const mutations = {
  ...crud.mutations,
  cacheDbOptions(state, data) {
    if (typeof data.LineBreak === 'string') {
      data.LineBreak = parseInt(data.LineBreak);
    }
    state.dbOptions = data;
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
